var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#E02126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5804 15.5816C10.3804 15.5816 10.1904 15.5016 10.0504 15.3616L7.22043 12.5316C6.93043 12.2416 6.93043 11.7616 7.22043 11.4716C7.51043 11.1816 7.99043 11.1816 8.28043 11.4716L10.5804 13.7716L15.7204 8.63156C16.0104 8.34156 16.4904 8.34156 16.7804 8.63156C17.0704 8.92156 17.0704 9.40156 16.7804 9.69156L11.1104 15.3616C10.9704 15.5016 10.7804 15.5816 10.5804 15.5816Z",
    fill: "#E02126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetAchievement);
export default __webpack_public_path__ + "static/media/target-achievement.a166df4fee1b4b0327540d2cd77563f5.svg";
export { ForwardRef as ReactComponent };